import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarClock, Send } from "lucide-react";
import { http } from "../lib/api";

const ymLabel = (ym) => ym && new Date(`${ym}-01T12:00:00`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });

export const MonthlyReportSettings = () => {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => http.get("/settings/monthly-report").then((r) => setCfg(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (enabled) => {
    await http.put("/settings/monthly-report", { enabled });
    toast.success(enabled ? "Envoi mensuel activé" : "Envoi mensuel désactivé"); load();
  };
  const test = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/settings/monthly-report/test");
      data.sent ? toast.success(`PDF de ${ymLabel(data.month)} envoyé à ${data.to}`) : toast.error(`Échec : ${data.reason || "raison inconnue"}`);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  if (!cfg) return null;
  const last = cfg.last_result;
  return (
    <div className="border border-slate-200 bg-white rounded-md p-6" data-testid="monthly-report-settings">
      <div className="flex items-center gap-2 mb-2"><CalendarClock className="h-5 w-5 text-sky-600" /><h2 className="font-display text-xl font-bold">Envoi mensuel du tableau de bord</h2></div>
      <p className="text-sm text-slate-600 mb-4">Chaque 1er du mois (vers 8h), le PDF du tableau de bord du mois écoulé est envoyé par e-mail à l&apos;administrateur principal : <b data-testid="monthly-report-recipient">{cfg.recipient || "—"}</b>.</p>
      <div className="flex flex-wrap items-center gap-3">
        <label className="inline-flex items-center gap-2 text-sm font-semibold cursor-pointer">
          <input data-testid="monthly-report-toggle" type="checkbox" checked={cfg.enabled} onChange={(e) => toggle(e.target.checked)} className="h-4 w-4" />
          Envoi automatique {cfg.enabled ? "activé" : "désactivé"}
        </label>
        <button data-testid="monthly-report-test-btn" onClick={test} disabled={busy} className="inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-md border border-slate-300 hover:bg-slate-50 disabled:opacity-60">
          <Send className="h-3.5 w-3.5" />{busy ? "Envoi…" : `Envoyer un test maintenant (${ymLabel(cfg.next_month)})`}
        </button>
      </div>
      {last && (
        <div data-testid="monthly-report-last" className={`mt-4 text-xs rounded-md px-3 py-2 border ${last.sent ? "text-emerald-700 bg-emerald-50 border-emerald-200" : "text-rose-700 bg-rose-50 border-rose-200"}`}>
          Dernier envoi ({last.trigger === "test" ? "test" : "automatique"}, {new Date(last.at).toLocaleString("fr-FR")}) — {ymLabel(last.month)} : {last.sent ? `envoyé à ${last.to}` : `échec : ${last.reason}`}
        </div>
      )}
    </div>
  );
};
